angular.module('bizmetryApp').controller('DatasourceConflictDialogController',
  function ($scope, $mdDialog, conflicts) {

    $scope.conflicts = conflicts || [];

    $scope.close = function () {
      $mdDialog.hide();
    };
  }
);